import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z"
      fill="#ABE3FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.99996 4.66675H15.3333C15.6869 4.66675 16.0261 4.80722 16.2761 5.05727C16.5261 5.30732 16.6666 5.64646 16.6666 6.00008V15.3334C16.6666 15.687 16.5261 16.0262 16.2761 16.2762C16.0261 16.5263 15.6869 16.6667 15.3333 16.6667H5.99996C5.64634 16.6667 5.3072 16.5263 5.05715 16.2762C4.8071 16.0262 4.66663 15.687 4.66663 15.3334V6.00008C4.66663 5.64646 4.8071 5.30732 5.05715 5.05727C5.3072 4.80722 5.64634 4.66675 5.99996 4.66675ZM10.1133 12.8134L12.7066 11.0801C12.7754 11.0353 12.8319 10.974 12.871 10.9018C12.9102 10.8296 12.9306 10.7488 12.9306 10.6667C12.9306 10.5847 12.9102 10.5039 12.871 10.4317C12.8319 10.3595 12.7754 10.2982 12.7066 10.2534L10.1133 8.52008C10.0382 8.46929 9.95062 8.4399 9.86005 8.43504C9.76949 8.43019 9.67931 8.45006 9.59917 8.49252C9.51904 8.53499 9.45196 8.59845 9.40512 8.67612C9.35829 8.75378 9.33346 8.84272 9.33329 8.93341V12.4001C9.33346 12.4908 9.35829 12.5797 9.40512 12.6574C9.45196 12.735 9.51904 12.7985 9.59917 12.841C9.67931 12.8834 9.76949 12.9033 9.86005 12.8985C9.95062 12.8936 10.0382 12.8642 10.1133 12.8134ZM18 16.6667V7.33341C18.3536 7.33341 18.6927 7.47389 18.9428 7.72394C19.1928 7.97399 19.3333 8.31313 19.3333 8.66675V16.6667C19.3333 17.374 19.0523 18.0523 18.5522 18.5524C18.0521 19.0525 17.3739 19.3334 16.6666 19.3334H8.66663C8.313 19.3334 7.97387 19.1929 7.72382 18.9429C7.47377 18.6928 7.33329 18.3537 7.33329 18.0001H16.6666C17.0202 18.0001 17.3594 17.8596 17.6094 17.6096C17.8595 17.3595 18 17.0204 18 16.6667Z"
      fill="white"
    />
  </svg>
);
const SvgPresentationsIndicatorColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgPresentationsIndicatorColored;
